<script lang="ts">
  import Hero from "@blocks/Containers/Hero.svelte";
  import Countdown from "@blocks/Countdown/Countdown.svelte";
  import ImageTitle from "@blocks/Image/ImageTitle.svelte";
  import ImageBlock from "@blocks/Image/ImageBlock.svelte";
  import HeroTitle from "@blocks/Text/HeroTitle.svelte";
  import Text from "@blocks/Text/Text.svelte";
  import ButtonsBlock from "@blocks/Buttons/ButtonsBlock.svelte";
  import Set from "@blocks/Set.svelte";
  import Actions from "@blocks/Buttons/Actions.svelte";
  import ButtonBlock from "@blocks/Buttons/ButtonBlock.svelte";
  import ButtonCloudBlock from "@blocks/Buttons/ButtonCloudBlock.svelte";
  import MediaSlider from "@blocks/Sliders/MediaSlider.svelte";
  import MiniBioBlock from "@blocks/Misc/MiniBioBlock.svelte";
  import StyledTextBlock from "@blocks/Text/StyledTextBlock.svelte";
  import ColumnBlock from "@blocks/Containers/ColumnBlock.svelte";
  import ContentCardBlock from "@blocks/Misc/ContentCardBlock.svelte";
  import VideoBlock from "@blocks/Misc/VideoBlock.svelte";
  import CodeBlock from "@blocks/Misc/CodeBlock.svelte";
  import TestimonialsBlock from "@blocks/Misc/TestimonialsBlock.svelte";
  import ThemeCard from "@blocks/Misc/ThemeCardBlock.svelte";

  export let block: any;

  const { type } = block;
</script>

{#if type === "hero"}
  <Hero {...block} />
{:else if type === "hero_title"}
  <HeroTitle {...block} />
{:else if type === "image_title"}
  <ImageTitle {...block} />
{:else if type === "text"}
  <Text {...block} />
{:else if type === "countdown"}
  <Countdown {...block} />
{:else if type === "buttons"}
  <ButtonsBlock {...block} />
{:else if type === "button_cloud"}
  <ButtonCloudBlock {...block} />
{:else if type === "button"}
  <ButtonBlock {...block} />
{:else if type === "set"}
  <Set {...block} />
{:else if type === "actions"}
  <Actions {...block} />
{:else if type === "media_slider"}
  <MediaSlider {...block} />
{:else if type === "mini_bio"}
  <MiniBioBlock {...block} />
{:else if type === "image"}
  <ImageBlock {...block} />
{:else if type === "styled_text"}
  <StyledTextBlock {...block} />
{:else if type === "column"}
  <ColumnBlock {...block} />
{:else if type === "content_card"}
  <ContentCardBlock {...block} />
{:else if type === "video_block"}
  <VideoBlock {...block} />
{:else if type === "code_block"}
  <CodeBlock {...block} />
{:else if type === "testimonials_block"}
  <TestimonialsBlock {...block} />
{:else if type === "theme_card_block"}
  <ThemeCard {...block} />
{/if}
